var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "editarInfoStreamax",
      attrs: { row: "", "justify-center": "" }
    },
    [
      _c("v-card", { attrs: { id: "cardDivTV" } }, [
        _c("div", [
          _c(
            "div",
            { staticClass: "cardnew", attrs: { align: "center" } },
            [
              _c("br"),
              _c(
                "v-flex",
                { attrs: { md10: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "rounded-card" },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticClass: "col-md-12",
                          attrs: { "lazy-validation": "" },
                          model: {
                            value: _vm.validForm,
                            callback: function($$v) {
                              _vm.validForm = $$v
                            },
                            expression: "validForm"
                          }
                        },
                        [
                          _c(
                            "v-container",
                            { attrs: { "grid-list-md": "" } },
                            [
                              _c(
                                "div",
                                { attrs: { align: "left" } },
                                [
                                  _c("v-flex", { attrs: { md12: "" } }, [
                                    _c(
                                      "h2",
                                      {
                                        staticClass: "h2_title",
                                        staticStyle: {
                                          "margin-top": "12px !important"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.esEdicion
                                                ? "Detalle Time Sync Streamax"
                                                : "Detalle Time Sync Streamax"
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              ),
                              _c("v-divider"),
                              _c("br"),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("p1", { staticClass: "h2_title" }, [
                                        _vm._v("Manually")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm4: "",
                                        md4: "",
                                        lg5: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("DatePicker", {
                                        attrs: {
                                          label: _vm.formFields.fecha.label,
                                          rules: [_vm.rules.required],
                                          value: _vm.selectedDate,
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.fecha.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.fecha,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.fecha.value"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm4: "",
                                        md4: "",
                                        lg5: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("TimePicker", {
                                        attrs: {
                                          label: _vm.formFields.time.label,
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.time.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.time,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.time.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("p1", { staticClass: "h2_title" }, [
                                        _vm._v("Auto")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label: _vm.formFields.satellite.label,
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.satellite.check,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.satellite,
                                              "check",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.satellite.check"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label: _vm.formFields.ntpSync.label,
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.ntpSync.check,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.ntpSync,
                                              "check",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.ntpSync.check"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm2: "",
                                        md2: "",
                                        lg3: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label:
                                            _vm.formFields.centerServerCheck
                                              .label,
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.centerServerCheck
                                              .check,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.centerServerCheck,
                                              "check",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.centerServerCheck.check"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm6: "",
                                        md6: "",
                                        lg7: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label:
                                            _vm.formFields.centerServer.label,
                                          items:
                                            _vm.formFields.centerServer.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedCenterServer,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.centerServer.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.centerServer,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.centerServer.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }